export enum ErrorState {
  CONNECTED_AFTER_START = 'CONNECTED_AFTER_START',
  INCOMPLETE_DATA = 'INCOMPLETE_DATA',
}
